// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"39232948","455":"202c3a1a"}[chunkId] + ".chunk.js";
};